/* eslint-disable react/no-array-index-key */

import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader, ModalFooter, Row, Col } from 'reactstrap';
import { toast } from 'react-toastify';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { ErrorBoundary, FormAlerts, Button, Field, PseudoStates } from '@cordata/buffet';
import { adminInstance as Admin } from '~/utils';

const PY_API_URL = `${process.env.REACT_APP_HOST_NAME}`;

const validationSchema = Yup.object().shape({
  url: Yup.string().required('URL is Required'),
  description: Yup.string().required('Description is Required'),
});

const NavigatorRedirectsForm = () => {
  const { id } = useParams();
  const history = useHistory();
  const [data, setData] = useState({});
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    setData({});
    setStatus('loading');

    if (id && id !== 'add') {
      Admin
        .get(`/navigator-redirect/${id}`)
        .then(({ data: { data: r } }) => {
          setData(r);
          setStatus('success');
        })
        .catch(() => setStatus('error'));
    } else {
      setStatus('success');
    }
  }, [id]);

  return (
    <Modal isOpen={!!id} backdrop="static" size="xl">
      <Formik
        name="NavigatorRedirect"
        enableReinitialize

        initialValues={{
          id: data && data.id,
          ...(data && data.attributes),
        }}

        validationSchema={validationSchema}

        onSubmit={(values, { setSubmitting, setErrors }) => {
          const method = values.id ? 'put' : 'post';
          const url = `/navigator-redirect${values.id ? `/${values.id}` : ''}`;

          const p = {
            ...[
              'url',
              'description',
            ].reduce((a, m) => ({
              ...a,
              [m]: values[m],
            }), {}),
          };

          const success = () => {
            toast.success('Successfully saved!');

            history.push('/toolbox/navigator-redirects');
          };

          Admin[method](url, p)
            .catch((e) => {
              toast.error('Oops! Something went wrong');

              setErrors({ server: e });
            })
            .then(() => success())
            .then(() => setSubmitting(false));
        }}
      >
        {({ isSubmitting, submitCount, errors }) => (
          <Form noValidate>
            <ModalHeader>{id === 'add' ? 'Add' : 'Edit'} Navigator Redirect</ModalHeader>

            <ModalBody className="p-0">
              { id !== 'add' && (
                <p className="m-3 muted">{PY_API_URL}/redirect?redirectUid={id}</p>
              )}
              <ErrorBoundary>
                { submitCount >= 1 && errors && <div className="p-3"><FormAlerts errors={errors} /></div> }

                {status === 'success' || id === 'add'
                ? (
                  <>
                    <fieldset disabled={isSubmitting}>
                      <Row form>
                        <Col sm>
                          <Field
                            name="url"
                            required
                          />
                        </Col>

                        <Col sm>
                          <Field
                            name="description"
                            required
                          />
                        </Col>
                      </Row>
                    </fieldset>
                  </>
                ) : <div className="pt-3"><PseudoStates status={status} /></div>
              }
              </ErrorBoundary>
            </ModalBody>

            <ModalFooter>
              <Button
                outline
                tag={Link}
                type="cancel"
                to="/toolbox/navigator-redirects"
              >
                Cancel
              </Button>

              <Button
                type="submit"
                disabled={isSubmitting}
              >
                Save
              </Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default NavigatorRedirectsForm;
